/* global axios */
import ApiClient from './ApiClient';

class CustomPromptAPI extends ApiClient {
  constructor() {
    super('custom_prompt', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  delete() {
    return axios.delete(this.url);
  }

  validatePrompt(content) {
    return axios.post(`${this.url}/validate_prompt`, { content });
  }
}

export default new CustomPromptAPI();
